<template>
  <modal @close_modal="close_modal" :title="$t('models_and_train_configs.model_title')" :loading="loading"
  >
    <template v-slot:content>

      <v-sparkline
          :model-value="valuesAsc"
          line-width="1"
          height="30"
          padding="10"
          width="400"
      ></v-sparkline>

      <model-list
      :threshold="threshold"
      :models="models"
      @models-changed="$emit('models-changed')"
      ></model-list>
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/Modal";
import ModelList from "@/components/models/ModelList";
export default {
  name: "ModelListInModal",
  data () {
    return {
      'loading': false,
    }
  },
  methods: {
    close_modal() {
      this.$emit('close_modal')
    },
  },
  computed: {
    valuesAsc() {
      // Return an inverse array of this.values
      return this.values.slice().reverse();
    },
    values () {
      let this2 = this;
      const threshold = Number(this2.threshold);
      const scoreKey = 'correct_' + Math.min(95, threshold);

      return this.models.map((model) => {
        if(!model.performance) {
          return 0;
        }
        let performance = JSON.parse(model.performance);
        const scoreValue = performance[scoreKey];
        if (scoreValue === undefined || scoreValue === null) {
          return 0;
        }
        return Math.round(scoreValue * 100);
      })
    }
  },
  components: {ModelList, Modal},
  props: {
    models: {required: true},
    threshold: {required: true}
  }
}
</script>

<style scoped>

</style>
